<template>
  <div class="form-group form-group--toggle" :class="classes" >
    <div class="form-element__container">
      <!-- Prepend slot-->
      <div v-if="$slots['prepend']" class="form-control__addon form-control__addon--prepend">
        <slot name="prepend"></slot>
      </div>

      <!-- Control and label -->
      <div class="form-control__container">        
        <input :id="control_id" ref="controlEl" @focus="fcOnFocus" @blur="fcOnBlur" class="form-control" type="checkbox" v-model="selected" :placeholder="_placeholder" v-bind="$attrs"  >
        <div class="form-control__label">        
          <span @click="control_value = offValue" class="form-control__toggle-label form-control__toggle-label--off mb-0 text-xs-right">{{offLabel}}</span>
          <label :for="control_id" class="switch"></label>
          <span @click="control_value = onValue" class="form-control__toggle-label form-control__toggle-label--on mb-0">{{onLabel}}</span>
        </div>
      </div>

      <!-- Append slot-->
      <div v-if="$slots['append']" class="form-control__addon form-control__addon--append">
        <slot name="append"></slot>
      </div>
    </div>

    <div class="flexbox row form-control__additional-content-slot">
      <!-- Errors -->
      <div v-if="show_error" class="form-control__error-text">{{errors[0]}}</div> 
      <!-- Helper slot -->
      <div v-else-if="$slots['help'] || $slots['default']" class="form-control__helper-text"> <!-- if there is no help, but default content, render an empty help block for flex spacing -->
        <slot name="help"></slot>
      </div>
      <!-- Default slot -->
      <slot></slot>
    </div>
    
  </div>
</template>

<script>
import FormControl from '../../mixins/form-control'
import Validatable from '../../mixins/validatable'

export default {

  name: 'NToggle',

  props: {
    onLabel: { type: String, required: true },
    offLabel: { type: String, required: true },
    onValue: { default: true },
    offValue: { default: false },
  },

  data() {
    return {
      selected: null,
    }
  },

  watch: {
    control_value: {
      handler: function() {
        this.selected = this.control_value == this.onValue
      },
      immediate: true,
    },

    selected: function() {
      this.control_value = this.selected ? this.onValue : this.offValue
    },
  },

  mixins: [FormControl, Validatable],
}
</script>